import { Component, EventEmitter, Event, h, State } from '@stencil/core';
import { TranslationValues } from '../../../models/ITranslationValues';
import { Translations } from '../../../helpers/TranslationUtils';
import { ApiCall } from '../../../helpers/ApiCall';

// @ts-ignore
import loaderImg from '../../../assets/loader.svg';
import logoOntrace from '../../../assets/logo-ontrace.svg';
import icoId from '../../../assets/landing/ico-id.svg';
import store from '../../../helpers/store';

@Component({
  tag: 'id-selection',
  styleUrl: 'id-selection.css',
})
export class IdSelection {
  private translations: TranslationValues;
  @State() yesButtonPressed: boolean;
  @State() noButtonPressed: boolean;

  @Event({
    eventName: 'apiError',
  })
  apiErrorEvent: EventEmitter<any>;

  async componentWillRender() {
    this.translations = await Translations.getValues();
  }

  async componentWillLoad() {
    this.yesButtonPressed = false;
    this.noButtonPressed = false;

    if (store.idType.startsWith('TD1')) {
      await this.hasBackSelected();
    }
  }

  private async hasBackSelected() {
    this.yesButtonPressed = true;
    try {
      await ApiCall.instance.SetTwoSidedId();
    } catch (e) {
      this.apiErrorEvent.emit(e);
    }
  }

  private async onlyFrontSelected() {
    this.noButtonPressed = true;
    try {
      store.flowStatus = await ApiCall.instance.GetNextFlowState();
    } catch (e) {
      this.apiErrorEvent.emit(e);
    }
  }

  render() {
    return (
      <div class="container flex center">
        <div class="px-3">
          <div class="mb-1 ml-1 text-center">
            <img src={icoId} style={{ width: '70px' }}></img>
          </div>
          <h1 class="text-center mb-1">{this.translations.IdSelectionValues.Title}</h1>
          <div class="color-blue mb-2 loud-text" innerHTML={this.translations.IdSelectionValues.Description}></div>

          {!this.noButtonPressed ? (
            <div class="button flex mb-1">
              {this.yesButtonPressed ? (
                <div class="img-loader rounded img-loader-button">
                  <img class="loading-image loading-image-button" src={loaderImg}></img>
                </div>
              ) : null}
              <button class="main-button" type="button" disabled={this.yesButtonPressed} onClick={() => this.hasBackSelected()}>
                {this.translations.IdSelectionValues.ButtonYes}
              </button>
            </div>
          ) : null}
          <div></div>
          {!this.yesButtonPressed ? (
            <div class="button flex mb-1">
              {this.noButtonPressed ? (
                <div class="img-loader rounded img-loader-button">
                  <img class="loading-image loading-image-button" src={loaderImg}></img>
                </div>
              ) : null}
              <button class="main-button" type="button" disabled={this.noButtonPressed} onClick={() => this.onlyFrontSelected()}>
                {this.translations.IdSelectionValues.ButtonNo}
              </button>
            </div>
          ) : null}

          <div class="footer text-center">
            <img src={logoOntrace}></img>
          </div>
        </div>
      </div>
    );
  }
}
